"use strict";
var logo = document.querySelector(".logo");
var promise1 = new Promise(function(resolve) {
    logo.addEventListener("click", function() {
        resolve();
    });
});
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        reject(new Error("Promise was rejected!"));
    }, 3000);
});
function createMessage(text) {
    var isError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var div = document.createElement("div");
    div.classList.add("message");
    if (isError) div.classList.add("error-message");
    div.textContent = text;
    document.body.appendChild(div);
}
promise1.then(function() {
    createMessage("Promise was resolved!");
}).catch(function() {
    createMessage("Promise was rejected!", true);
});
promise2.then(function() {
    createMessage("Promise was resolved!");
}).catch(function() {
    createMessage("Promise was rejected!", true);
});

//# sourceMappingURL=index.2d04f2b6.js.map
